import React from 'react';
import './Portfolio.css';
import { FaRocket } from 'react-icons/fa';

function Portfolio() {
  const projects = [
    {
      name: 'ForceDesk',
      icon: 'https://cdn.forcedesk.io/img/forcedesk-icon-test.svg',
      description: 'A comprehensive helpdesk system built with Laravel Framework. Provides ticket management, asset tracking, and more.',
      technologies: ['Laravel', 'MariaDB', 'Redis'],
      link: 'https://www.forcedesk.io'
    },
    {
      name: 'ForcePoint OPS',
      icon: 'https://cdn.forcedesk.io/img/forcedesk-icon-test.svg',
      description: 'Work Order Management System for educational institutions. Streamlines work orders, resource allocation, and operational reporting.',
      technologies: ['Laravel', 'MariaDB', 'Redis'],
      link: 'https://www.forcepointsoftware.com.au'
    },
    {
      name: 'ForcePoint EMS',
      icon: 'https://cdn.forcedesk.io/img/forcedesk-icon-test.svg',
      description: 'Integrated with ForcePoint OPS, allows schools to streamline evacuation procedures through audible alerts and webhooks.',
      technologies: ['Laravel', 'Swift', 'Kotlin'],
      link: 'https://www.forcepointsoftware.com.au'
    },
    {
      name: 'My School Rewards',
      icon: '/img/myrewards.png',
      description: 'Engaging and easy to use rewards system for schools. Reward students good behaviour with points they can redeem in an online shop.',
      technologies: ['Laravel', 'ReactJS', 'Inertia', 'Tailwind'],
      link: null
    },
    {
      name: 'CASES21 Subprogram Report Generator',
      icon: '/img/civica.jpg',
      description: 'Automated reporting tool for DE CASES21 financial data. Generates subprogram reports and financial summaries for Victorian government schools to streamline Business Manager and Bursar duties.',
      technologies: ['Laravel', 'CASES21'],
      link: null
    }
  ];

  return (
    <div className="portfolio">
      <h2><FaRocket className="section-icon" /> Stuff I have been working on</h2>
      <div className="projects-list">
        {projects.map((project, index) => (
          <div key={index} className="project-item">
            <div className="project-icon">
              <img src={project.icon} alt={`${project.name} logo`} />
            </div>
            <div className="project-details">
              <h3>{project.name}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
              {project.link && (
                <a href={project.link} className="project-link">More Info →</a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Portfolio;
